import { render, staticRenderFns } from "./BasicTestModal.vue?vue&type=template&id=14f49c7e"
import script from "./BasicTestModal.vue?vue&type=script&lang=js"
export * from "./BasicTestModal.vue?vue&type=script&lang=js"
import style0 from "./BasicTestModal.vue?vue&type=style&index=0&id=14f49c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports